module.exports = __webpack_public_path__ + "img/Dantam Makeover 31.a4217dd7.jpg";